import { NgModule } from '@angular/core';
import { CancelaAgendaClientComponent } from 'src/app/client/cancela-agenda-client/cancela-agenda-client.component';
import { TrocaSenhaComponent } from 'src/app/user/troca-senha/troca-senha.component';
import { RecuperaSenhaComponent } from 'src/app/user/recupera-senha/recupera-senha.component';
import { LoginComponent } from 'src/app/user/login/login.component';
import { CadastroComponent } from 'src/app/user/cadastro/cadastro.component';
import { CadastroAsaasComponent } from '../user/cadastro-asaas/cadastro-asaas.component';
import { MinhaAgendaClientComponent } from 'src/app/client/minha-agenda-client/minha-agenda-client.component';
import { AgendamentostepperClientComponent } from 'src/app/client/agendamentostepper-client/agendamentostepper-client.component';
import { HorariosClientComponent } from 'src/app/client/horarios-client/horarios-client.component';
import { ResumoClientComponent } from 'src/app/client/resumo-client/resumo-client.component';
import { ConvenioClientComponent } from 'src/app/client/convenio-client/convenio-client.component';
import { Routes, RouterModule } from '@angular/router';
import { AutoLoginComponent } from './auto-login/auto-login.component';

const routes: Routes = [{
  path: '',
  pathMatch: 'full',
  redirectTo: 'agendamento'
},
{
  path: 'convenio',
  component: ConvenioClientComponent
},
{
  path: 'resumo',
  component: ResumoClientComponent
},
{
  path: 'horarios',
  component: HorariosClientComponent
},
{
  path: 'agendamento',
  component: AgendamentostepperClientComponent
},
{
  path: 'meus-agendamentos',
  component: MinhaAgendaClientComponent
},
{
  path: 'atualizar-cadastro',
  component: CadastroComponent,  //AtualizaComponent
  data: {
    action: 'UPD'
  }
},
{
  path: 'meus-dados',
  component: CadastroComponent,  //AtualizaComponent
  data: {
    action: 'UPD'
  }
},
{
  path: 'cadastro',
  component: CadastroComponent,
  data: {
    action: 'INS'
  }
},
{
  path: 'cadastro-asaas',
  component: CadastroAsaasComponent
},
{
  path: 'login',
  component: LoginComponent
},
{
  path: 'recuperasenha/:email',
  component: RecuperaSenhaComponent
},
{
  path: 'recovery',
  component: TrocaSenhaComponent
},
{
  path: 'auto-login/:token',
  component: AutoLoginComponent
},
{
  path: 'cancela/:id',
  component: CancelaAgendaClientComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientRoutingModule { }
